// ==========================================
// frontend/src/components/ContactInfo.jsx

import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";

const ContactInfo = () => {
  const contactItems = [
    {
      icon: FaPhone,
      title: "Téléphone",
      content: "+216 51 41 88 80",
      link: "tel:+21651418880",
    },
    {
      icon: FaEnvelope,
      title: "Email",
      content: "contact@seengineering-tn.com",
      link: "mailto:contact@seengineering-tn.com",
    },
    {
      icon: FaMapMarkerAlt,
      title: "Adresse",
      content: "12 Rue 18 janvier, KSIBET EL MEDIOUNI 5031- Tunisie",
      link: null,
    },
    {
      icon: FaClock,
      title: "Horaires",
      content: "Lun-Ven: 9h-18h",
      link: null,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {contactItems.map((item, index) => (
        <div
          key={index}
          className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 flex-shrink-0">
            <item.icon size={24} />
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 mb-1">{item.title}</h3>
            {item.link ? (
              <a
                href={item.link}
                className="text-gray-600 hover:text-blue-600 transition-colors"
              >
                {item.content}
              </a>
            ) : (
              <p className="text-gray-600">{item.content}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactInfo;
